import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Spinner } from '../components/ui/misc'
import { AdminLogin } from './Login'
import { AdminLayout } from './pages/AdminLayout'

const page = <T extends string>(load: () => Promise<Record<T, React.ComponentType>>, name: T) =>
  lazy(() => load().then((m) => ({ default: m[name] })))
const AdminOverview = page(() => import('./pages/Overview'), 'AdminOverview')
const AdminWaitlist = page(() => import('./pages/Waitlist'), 'AdminWaitlist')
const AdminOrgs = page(() => import('./pages/Orgs'), 'AdminOrgs')
const AdminOrgDetail = page(() => import('./pages/Orgs'), 'AdminOrgDetail')
const AdminUsers = page(() => import('./pages/Users'), 'AdminUsers')
const AdminCredits = page(() => import('./pages/Credits'), 'AdminCredits')
const AdminSettings = page(() => import('./pages/Settings'), 'AdminSettings')
const AdminAudit = page(() => import('./pages/Audit'), 'AdminAudit')
const AdminTeam = page(() => import('./pages/Team'), 'AdminTeam')
const AdminGpu = page(() => import('./pages/Gpu'), 'AdminGpu')

/** The admin app (its own host): the CRM for beta access, organizations, credits and the audit log. */
export default function AdminApp() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="waitlist" element={<AdminWaitlist />} />
          <Route path="orgs" element={<AdminOrgs />} />
          <Route path="orgs/:id" element={<AdminOrgDetail />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="credits" element={<AdminCredits />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="audit" element={<AdminAudit />} />
          <Route path="team" element={<AdminTeam />} />
          <Route path="gpu" element={<AdminGpu />} />
        </Route>
        {/* old console-style links (/admin/...) */}
        <Route path="admin/*" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
